import { render, staticRenderFns } from "./DueInvoice.vue?vue&type=template&id=71457eb2&scoped=true&"
import script from "./DueInvoice.vue?vue&type=script&lang=js&"
export * from "./DueInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DueInvoice.vue?vue&type=style&index=0&id=71457eb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71457eb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VCard,VCardText,VContainer,VDataTable,VIcon,VProgressLinear})
